/*!
 * Laki – Fly to Cart
 * Listens in the CAPTURE phase so e.stopPropagation() on any element's own
 * bubble-phase handler never blocks the animation.
 * Direct API: window.LakiFlyToCart.fly(sourceElement, { image, color })
 * Auto-intercepts: [data-atc-main] and [data-fly-to-cart] on click.
 */
(function () {
  'use strict';

  var ACCENT = '#cc0000';

  // Inject badge-pop keyframe once
  var styleEl = document.createElement('style');
  styleEl.textContent =
    '@keyframes laki-badge-pop{'
    + '0%{transform:scale(1)}'
    + '28%{transform:scale(1.55)}'
    + '52%{transform:scale(0.87)}'
    + '74%{transform:scale(1.18)}'
    + '100%{transform:scale(1)}'
    + '}'
    + '[data-cart-count].laki-badge-pop{'
    + 'animation:laki-badge-pop .48s cubic-bezier(.36,.07,.19,.97) both'
    + '}';
  document.head.appendChild(styleEl);

  // Resolve the cart icon target — multiple fallbacks for robustness
  function getCartTarget() {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return null;
    return (
      badge.closest('[data-drawer-trigger*="laki-cart"]') ||
      badge.closest('.site-header__cart-link') ||
      badge.closest('a[href*="/cart"]') ||
      badge.closest('[data-cart-toggle]') ||
      badge.closest('button') ||
      badge.closest('a') ||
      badge
    );
  }

  function fly(sourceEl, opts) {
    opts = opts || {};
    if (!sourceEl) return;

    var target = getCartTarget();
    if (!target) return;

    var sRect = sourceEl.getBoundingClientRect();
    var tRect = target.getBoundingClientRect();
    var SIZE  = 36;

    var startX = sRect.left + sRect.width  / 2 - SIZE / 2;
    var startY = sRect.top  + sRect.height / 2 - SIZE / 2;
    var endX   = tRect.left + tRect.width  / 2 - SIZE / 2;
    var endY   = tRect.top  + tRect.height / 2 - SIZE / 2;

    // Skip if source and target overlap
    if (Math.abs(startX - endX) < 24 && Math.abs(startY - endY) < 24) return;

    // Build the flying bubble
    var flier = document.createElement('div');
    flier.setAttribute('aria-hidden', 'true');
    flier.style.cssText =
      'position:fixed;z-index:99999;pointer-events:none;'
      + 'width:' + SIZE + 'px;height:' + SIZE + 'px;border-radius:50%;'
      + 'background:' + (opts.color || ACCENT) + ';'
      + 'display:flex;align-items:center;justify-content:center;overflow:hidden;'
      + 'box-shadow:0 4px 14px rgba(0,0,0,.45);'
      + 'top:0;left:0;'
      // Position via transform immediately so there is no flash at (0,0)
      + 'transform:translate(' + startX + 'px,' + startY + 'px) scale(1);';

    if (opts.image) {
      var img = document.createElement('img');
      img.src = opts.image;
      img.alt = '';
      img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
      flier.appendChild(img);
    } else {
      // Mini cart icon inside the bubble
      flier.innerHTML =
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" '
        + 'stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>'
        + '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>'
        + '</svg>';
    }

    document.body.appendChild(flier);

    // Arc mid-point: pulled above both endpoints
    var midX  = (startX + endX) / 2;
    var arcUp = Math.max(70, Math.abs(endY - startY) * 0.55);
    var midY  = Math.min(startY, endY) - arcUp;

    var anim = flier.animate([
      { transform: 'translate(' + startX + 'px,' + startY + 'px) scale(1)',    opacity: 1 },
      { transform: 'translate(' + midX   + 'px,' + midY   + 'px) scale(0.78)', opacity: 1,  offset: 0.44 },
      { transform: 'translate(' + endX   + 'px,' + endY   + 'px) scale(0.18)', opacity: 0 }
    ], { duration: 900, easing: 'cubic-bezier(.25,.46,.45,.94)', fill: 'forwards' });

    anim.addEventListener('finish', function () {
      flier.remove();
      // Bounce the cart badge
      var badge = document.querySelector('[data-cart-count]');
      if (badge) {
        badge.classList.remove('laki-badge-pop');
        void badge.offsetWidth; // force reflow to restart the animation
        badge.classList.add('laki-badge-pop');
      }
    });
  }

  // ── Global delegation ───────────────────────────────────────────────────────
  // CAPTURE phase (third arg = true) fires BEFORE any element's own bubble-phase
  // handler, so e.stopPropagation() inside those handlers cannot block this.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc-main], [data-fly-to-cart]');
    if (!btn) return;

    // Skip buttons already processing or unavailable
    var state = btn.dataset.state;
    if (state === 'loading' || state === 'sold-out') return;
    if (btn.disabled) return;

    var card  = btn.closest('[data-product-card], .product-card, .dotd-card, .card, article, li');
    var imgEl = card ? card.querySelector('img[src]') : null;
    fly(btn, { image: imgEl ? imgEl.src : null });
  }, true); // ← capture phase

  window.LakiFlyToCart = { fly: fly };
})();
